<template>
  <div>

    <div class="pt-5 pb-4 tac">
      
      <h2 class="mb-3">
        {{lg('',{
          en: 'Farming Pool',
          zh: '质押挖矿池',
        })}}
      </h2>
      <div class="mx-auto px-4 i mb-4" style="max-width: 500px;">
        {{lg('',{
          en: 'Stake ONLY HECO format tokens or the LP tokens from LavaSwap to earn rewards. You can unstake at any time. Rewards are calculated per block.',
          zh: '目质押挖矿池目前只支持HECO的代币形式或者通过LAVAswap添加流动性得到的LP代币。您可以随时取消质押或者取出您的奖励。奖励是按每个区块计算的。',
        })}}
      </div>

      <div class="">
        <div class="ui-tabset" style="max-width: 250px;">
          <span 
            :class="['tab size-big',{'on': on_tab == 'active'}]"
            @click="on_tab = 'active'"
          >
            {{lg('',{
              en: 'Active',
              zh: '进行中',
            })}}
          </span>
          <span 
            :class="['tab size-big',{'on': on_tab == 'inactive'}]"
            @click="on_tab = 'inactive'"
          >
            {{lg('',{
              en: 'Inactive',
              zh: '已结束',
            })}}
          </span>
        </div>
      </div>

      <div class="tac mt-4 d-flex align-items-center justify-content-center">
        <span  
          @click="status_view_staked = !status_view_staked" 
          :class="['btn-switch no-dark-mode bg-light-c',{'on-right green': status_view_staked}]"
          style="width: 40px;"
          >
          <span class="switch-thumb"></span>
        </span>
        <span class="ml-2">
          {{lg('',{
            en: 'Staked Only',
            zh: '仅看有质押',
          })}}
        </span>
      </div>


    </div>

    <div class="container my-4" style="max-width: 900px;">

      <!-- list active -->
      <div v-if="on_tab === 'active'" class="list-farm-cards mt-5">
        <div 
          class="item mb-4"
          v-for="item of main_list_stake"
          :key="item.id"
          >
          <farmCard 
            :cfg_view_staked="status_view_staked"
            :item="item"/>
        </div>
      </div>

      <!-- list inactive -->
      <div v-if="on_tab === 'inactive'" class="list-farm-cards mt-5">
        <div 
          class="item mb-4"
          v-for="item of main_list_stake_inactive"
          :key="item.id"
          >
          <farmCard 
            :cfg_view_staked="status_view_staked"
            :item="item" :card_cfg="{
            status_inactive: false,
          }"/>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import main_list_stake from '@/data/main_list_stake.js'
import main_list_stake_inactive from '@/data/main_list_stake_inactive.js'
import farmCard from './farmCard.vue'

export default {
  name: 'farm',
  components: {
    farmCard,
  },
  props: [],
  data() {
    return {
      on_tab: 'active',
      main_list_stake: main_list_stake,
      main_list_stake_inactive: main_list_stake_inactive,

      status_view_staked: false,
    }
  },
  computed: {},
  watch: {},
  methods: {
    autoSetTab(){
      let v = this
      if( v.$route.query.tab ){
        v.on_tab = v.$route.query.tab
      }
    },
  },
  created() {
    this.autoSetTab()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .list-farm-cards{
    display: flex;
    flex-wrap: wrap;

    .item{
      &:empty{
        display: none;
      }
    }

    // mobile
    @media(max-width: 788px){
      margin: 0 10px;
      .item{
        // width: 100%;
        width: 50%;
      }
    }

    // pc
    @media(min-width: 788px){
      .item{
        width: 33%;
      }
    }
  }
</style>